import React from 'react'
import classNames from 'classnames'

const ToggleButton = ({ toggleValues, toggleValue, setToggleValue, labelLeft, labelRight }) => {
  const toggleButtonClassNames = classNames('lc-toggle-button', {
    'lc-toggle-button--left': toggleValue === toggleValues[0],
    'lc-toggle-button--right': toggleValue === toggleValues[1]
  })

  const handleOnClick = () => {
    toggleValue === toggleValues[0]
      ? setToggleValue(toggleValues[1])
      : setToggleValue(toggleValues[0])
  }

  return (
    <div className={toggleButtonClassNames}>
      {labelLeft && (
        <span className='lc-toggle-button__label lc-toggle-button__label--left'>
          {labelLeft}
        </span>
      )}
      <button className='lc-toggle-button__button' onClick={handleOnClick}/>
      {labelRight && (
        <span className='lc-toggle-button__label lc-toggle-button__label--right'>
          {labelRight}
        </span>
      )}
    </div>
  )
}

export default ToggleButton
